export default {"src":"/_next/static/media/Appstore.6320e7cc.svg","height":44,"width":148,"blurWidth":0,"blurHeight":0};